import { defineMessages } from 'react-intl'

export default defineMessages({
  submit: {
    id: 'registrationpage.form.submit',
    defaultMessage: 'Submit',
  },
  continue: {
    id: 'registrationpage.form.continue',
    defaultMessage: 'Continue',
  },
  termsAndConditionsRequired: {
    id: 'registrationpage.form.termsandconditionsrequired',
    defaultMessage: 'You must read and accept the terms and conditions',
  },
})
